import { Component, computed, inject, input, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ApiErrorService } from '@app/shared/services/api-error.service';
import { ApiError } from '@app/shared/types/models/api-error.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-api-error-banner',
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './api-error-banner.component.html'
})
export class ApiErrorBannerComponent {
  private readonly apiErrorService: ApiErrorService = inject(ApiErrorService);

  protected readonly translationKeys: Signal<string[]> = computed(() =>
    this.errors().map(error => this.apiErrorService.getTranslationKey(error))
  );

  public readonly errors = input<ApiError[]>([]);
}
